<div class="ion-text-center ion-padding-vertical">
    <ion-spinner
        [style.--color]="color"
        [style.width]="size || undefined"
        [style.height]="size || undefined"></ion-spinner>
</div>
